export default "__VITE_ASSET__Dio3z8xY__"